import { chunk } from "../../util/util";
import styles from './Grid.module.css'

const Grid = ({ children, cols, gap }) => (
    <div style={{marginTop: gap}}>
        {
            chunk(children, cols).map((childrenSubSet, index) => (
                <Row key={index} gap={gap}>
                    { childrenSubSet }
                </Row>
            ))
        }
    </div>
)

const Row = ({ children, gap }) => (
    <div className={ styles.gridRow } style={{ gap, marginBottom: gap }}>
        { children }
    </div>
)

const Item = ({ children }) => (
    <div className={ styles.gridItem }>
        { children }
    </div>
)

export default Grid
export { Item }
